
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import FillFollowModal from '../subassembly/FillFollowModal.vue';
import FillFollowDrawer from '../subassembly/FillFollowDrawer.vue';

@Component({
  components: {
    FillFollowModal,
    FillFollowDrawer,
  },
})
export default class ShouldBeCharged extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @Ref('fillFollowModal')
  fillFollowModal?: any;

  @Ref('fillFollowDrawer')
  fillFollowDrawer?: any;

  pagination: any = {
    pageSize: 10,
    current: 1,
    total: 0,
    onChange: this.paginationChange,
  };
  dataSource: any = [
    // {
    //   shop_name: '测试门店',
    //   shop_status: '正常',
    //   shop_id: '123',
    //   total_recharge_amount: 1000,
    //   recharge_count: 10,
    //   average_recharge: 100,
    //   days_of_advertisement: 10,
    //   average_daily_consumption_30: 100,
    //   average_daily_consumption_7: 100,
    //   daily_budget: 100,
    //   balance: 100,
    //   recharge_reason: '测试',
    // },
  ];
  columns = [
    {
      title: '店铺名称',
      dataIndex: 'shop_name',
      align: 'center',
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      align: 'center',
    },
    {
      title: '广告主ID',
      dataIndex: 'advertiser_id',
      align: 'center',
    },
    {
      title: '近7天推广通消耗金额',
      dataIndex: 'cost',
      align: 'center',
    },
    {
      title: '推广通余额',
      dataIndex: 'advertiser_amount',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },

  ];
  module: any = '';
  @Watch('$route')
  onRouteChange() {
    const { page, pageSize, module } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (module) {
      params.module = module;
      this.module = module;
    }
    this.pagination.current = Number(page);
    this.pagination.pageSize = Number(pageSize);
    this.getList(params);
  }
  goToShopDetail(id: string) {
    const routeUrl = this.$router.resolve({
      name: 'main.shop.detail',
      params: {
        id: `${id}`,
      },
    });
    window.open(routeUrl.href, '_blank');
  }
  back() {
    this.$router.push({
      name: 'workbenches.index',
    });
  }
  async getList(params: any) {
    const res = await this.workbenchesService.getMyTodoList(params);
    if (res) {
      this.dataSource = res.list;
      this.pagination.current = res.page;
      this.pagination.total = res.total;
    }
  }

  // handleClick(record: any) {
  //   console.log(record);
  // }

  writeFollow(value: any) {
    this.fillFollowModal.init(value);
  }

  lookFollow(value: any) {
    this.fillFollowDrawer.init(value);
  }

  mounted() {
    this.onRouteChange();
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const query: any = {
      page,
      pageSize,
      module: this.module,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
}
